import { cn } from '@/lib/utils';

interface Props {
  /** Hauteur du logo en classes tailwind, ex: 'h-8', 'h-10', 'h-12'. Défaut: 'h-10'. */
  size?: string;
  className?: string;
}

/**
 * Logo officiel Bar L'Alambic — version avec fond gris foncé + bordure
 * dorée intégrés dans l'image. Source : Marina Fontaine 2021.
 *
 * L'image bar_lalambic.png contient déjà tout le frame visuel (cercle
 * gris foncé + ring doré + alambic), donc pas besoin de wrapper CSS
 * additionnel — on rend juste l'img.
 */
export default function Logo({ size = 'h-10', className }: Props) {
  return (
    <img
      src="/images/bar_lalambic.png"
      alt="Bar L'Alambic — L'univers de la dégustation"
      className={cn('w-auto shrink-0 select-none', size, className)}
      draggable={false}
    />
  );
}
